import React from 'react';

const JobListings = () => {
  const jobs = [
    {
      id: 1,
      title: "Senior AI Research Scientist",
      department: "Research & Development",
      location: "Bengaluru, India",
      type: "Hybrid",
      description:
        "Lead cutting-edge AI research projects and mentor junior researchers in developing next-generation AI education tools.",
      requirements: [
        "Experience in AI/ML or related field",
        "5+ years R&D experience",
        "Experience in patent filing and IP management"
      ],
      tags: ["Research", "Leadership", "Hybrid"]
    },
    {
      id: 2,
      title: "AI Education Curriculum Designer",
      department: "Education",
      location: "Remote",
      type: "Remote",
      description:
        "Design innovative AI curriculum for students worldwide, working with educators to democratize AI education.",
      requirements: [
        "Master's in Education or AI",
        "Curriculum design experience",
        "Understanding of pedagogy"
      ],
      tags: ["Education", "Design", "Remote"]
    },
    {
      id: 3,
      title: "Marketing Manager - AI Products",
      department: "Marketing",
      location: "Bengaluru, India",
      type: "On-site",
      description:
        "Drive marketing strategy and campaigns for AI education tools. Collaborate with product, sales, and content teams.",
      requirements: [
        "Bachelor's degree in Marketing or related",
        "3+ years experience in product marketing",
        "Strong communication skills"
      ],
      tags: ["Marketing", "Strategy", "On-site"]
    },
    {
      id: 4,
      title: "Sales Executive - AI Solutions",
      department: "Sales",
      location: "Bengaluru, India",
      type: "Hybrid",
      description:
        "Generate leads, close deals, and manage client relationships for AI education and research products.",
      requirements: [
        "Bachelor’s in Business or related",
        "Proven sales track record",
        "Excellent interpersonal skills"
      ],
      tags: ["Sales", "Client Relations", "Hybrid"]
    },
    {
      id: 5,
      title: "Intern - AI Developer",
      department: "Engineering",
      location: "Remote",
      type: "Remote",
      description:
        "Work with senior engineers to build AI features for educational platforms. Great learning opportunity for students.",
      requirements: [
        "Currently pursuing CS/AI degree",
        "Knowledge on ML & AI libraries",
        "Eagerness to learn"
      ],
      tags: ["Internship", "AI", "Remote"]
    }
  ];

  return (
    <div style={styles.container} data-component="container">
      <style>
        {`
          /* --- Hover Effects --- */
          [data-component="job-card"]:hover {
            transform: translateY(-5px) scale(1.02);
            background: rgba(255, 255, 255, 0.08);
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
          }
          [data-component="apply-button"]:hover {
            transform: scale(1.05);
            box-shadow: 0 6px 20px rgba(139, 92, 246, 0.4);
          }

          /* --- Responsive Design --- */
          @media (max-width: 768px) {
            [data-component="container"] {
              padding: 40px 15px !important;
            }
            [data-component="title"] {
              font-size: 38px !important;
            }
            [data-component="job-card"] {
              padding: 25px !important;
            }
            [data-component="job-header"] {
              flex-direction: column !important;
              align-items: stretch !important;
            }
            [data-component="apply-button"] {
              text-align: center;
            }
            [data-component="job-title"] {
              font-size: 22px !important;
            }
            [data-component="job-meta"] {
              gap: 15px !important;
            }
          }
        `}
      </style>
      <div style={styles.header}>
        <h1 style={styles.title} data-component="title">Open Positions</h1>
      </div>
      
      <div style={styles.jobList}>
        {jobs.map(job => (
          <div key={job.id} style={styles.jobCard} data-component="job-card">
            <div style={styles.jobHeader} data-component="job-header">
              <div style={styles.jobInfo}>
                <h2 style={styles.jobTitle} data-component="job-title">{job.title}</h2>
                <div style={styles.jobMeta} data-component="job-meta">
                  <span style={styles.metaItem}><span style={styles.icon}>🏢</span>{job.department}</span>
                  <span style={styles.metaItem}><span style={styles.icon}>📍</span>{job.location}</span>
                  <span style={styles.metaItem}><span style={styles.icon}>🕒</span>{job.type}</span>
                </div>
              </div>
            </div>
            
            <p style={styles.description}>{job.description}</p>
            
            <div style={styles.requirements}>
              <h3 style={styles.requirementsTitle}>Requirements:</h3>
              <ul style={styles.requirementsList}>
                {job.requirements.map((req, index) => (
                  <li key={index} style={styles.requirementItem}>
                    <span style={styles.bulletPoint}>•</span>
                    {req}
                  </li>
                ))}
              </ul>
            </div>
            
            <div style={styles.tags}>
              {job.tags.map((tag, index) => (
                <span key={index} style={styles.tag}>{tag}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#0a0a0a',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px'
  },
  title: {
    fontSize: '48px',
    fontWeight: '700',
    color: '#ffffff',
    margin: '0',
    textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)'
  },
  jobList: {
    maxWidth: '1000px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px'
  },
  jobCard: {
    background: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '20px',
    padding: '30px',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
  },
  jobHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '20px',
    gap: '20px',
    flexWrap: 'wrap'
  },
  jobInfo: {
    flex: '1',
    minWidth: '300px'
  },
  jobTitle: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#ffffff',
    margin: '0 0 15px 0'
  },
  jobMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.8)'
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  icon: {
    fontSize: '14px',
    opacity: '0.7'
  },
  applyButton: {
    background: 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '12px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(139, 92, 246, 0.3)',
    whiteSpace: 'nowrap'
  },
  description: {
    fontSize: '16px',
    color: 'rgba(255, 255, 255, 0.9)',
    lineHeight: '1.6',
    margin: '0 0 25px 0'
  },
  requirements: {
    marginBottom: '25px'
  },
  requirementsTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#ffffff',
    margin: '0 0 12px 0'
  },
  requirementsList: {
    listStyle: 'none',
    padding: '0',
    margin: '0'
  },
  requirementItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.8)',
    marginBottom: '8px',
  },
  bulletPoint: {
    color: '#a855f7',
    lineHeight: 'inherit',
  },
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px'
  },
  tag: {
    background: 'rgba(139, 92, 246, 0.2)',
    color: '#c084fc', // Lighter purple for better contrast
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500',
    border: '1px solid rgba(139, 92, 246, 0.3)'
  }
};

export default JobListings;